import { render } from "./AddPreLesson.vue?vue&type=template&id=5444a548&scoped=true"
import script from "./AddPreLesson.vue?vue&type=script&lang=js"
export * from "./AddPreLesson.vue?vue&type=script&lang=js"

import "./AddPreLesson.vue?vue&type=style&index=0&id=5444a548&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5444a548"]])

export default __exports__